import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppComponent } from '@/app.component';
import { SecureData } from './models';

@Component({
  selector: 'app-webrtcfeeds',
  templateUrl: './webrtcfeeds.component.html',
  styleUrls: ['./webrtcfeeds.component.scss']
})


export class WebrtcfeedsComponent implements OnInit, OnDestroy {

  public currentScreen: 'WebrtcfeedsScreen' | 'AccessDeniedScreen' | 'WebrtcfeedsErrorScreen' = 'WebrtcfeedsScreen';

  year: number;
  player: any;
  public version: string = "";

  public streamName: string = "";
  public applicationName: string = "";
  public wssUrl: string = "";
  public TokenExpiryTime: string = "";
  public LocalExpiryDate: Date = new Date();

  public prefix: string = "";
  public SharedKey: string = "";
  public wowzatimeout: number = 1440; // seconds
  public isIp: boolean = false;
  public ip: string = "";
  public siteCompany: string = "";
  wsConnection: WebSocket | null = null;
  videoElement: HTMLVideoElement | null = null;
  peerConnection: RTCPeerConnection | null = null;
  repeaterRetryCount = 0;


  constructor(app: AppComponent) {

    this.year = new Date().getFullYear();
    this.currentScreen = app.getAttribute("screen");

     this.wssUrl = window["wssUrl"];
     this.streamName = window["streamName"];
     this.applicationName = window["applicationName"];
     this.TokenExpiryTime = window["TokenExpiryTime"];
    
     this.SharedKey = window["SharedKey"];
     this.prefix = window["prefix"];
     this.wowzatimeout = window["wowzatimeout"];
     this.isIp = false;
    this.ip = '127.0.0.1';
    this.version = window["version"];
     this.siteCompany = window["siteCompany"];
    //this.streamName = "BWV";
    //this.applicationName = "replica";
    //this.wssUrl = "wss://media-server-trial2.mview.com.au:443/webrtc-session.json";
    //this.TokenExpiryTime = '6/27/2025 1:24:36 PM';
    //this.prefix = 'wowzatoken';
    //this.SharedKey = 'replicasharedsecretkey';
    //this.wowzatimeout = 1440; // seconds
    //this.isIp = false;
    //this.ip = '127.0.0.1';

    this.LocalExpiryDate = new Date(this.TokenExpiryTime + ' UTC');
    // console.log(this.LocalExpiryDate);
    // console.log('constructor');
    // console.log('currentScreen ' + this.currentScreen);
    // console.log('streamName ' + this.streamName);
    // console.log('applicationName ' + this.applicationName);
    // console.log('wssUrl ' + this.wssUrl);

  }
  
  ngOnInit() {
    //console.log('ngOnInit');
    
  }
  
  ngAfterViewInit(): void {
    //console.log('ngAfterViewInit');

    if (this.currentScreen === "WebrtcfeedsScreen") {
      if (this.applicationName === "" || this.streamName === "" || this.wssUrl === "") {
        alert("Please fill out the connection details");
      } else {
        this.videoElement = document.getElementById("player-video") as HTMLVideoElement;
        this.wsConnect();
      }
    }
  }

  ngOnDestroy() {
    //console.log('ngOnDestroy');
    this.stop();
  }

  async wsConnect() {

    const secureData: SecureData = {
      applicationName: this.applicationName,
      streamName: this.streamName,
      prefix: this.prefix,
      SharedKey: this.SharedKey,
      wowzatimeout: this.wowzatimeout,
      isIp: this.isIp,
      ip: this.ip,
      hash: '',
    };

    console.log("secureData: " + JSON.stringify(secureData));



    await this.parseStreamNameAndToken(this.streamName, secureData)
    .then((result) => {
      console.log("parseStreamNameAndToken result" , result)
      this.streamName = result; // Update streamName after token generation
      console.log('Processed Stream Name:', result);
    })
    .catch((error) => {
      console.error('Error in token generation:', error);
    });

    const streamInfo = {
      applicationName: this.applicationName,
      streamName: this.streamName,
      sessionId: '[empty]'
    };
    console.log("streamInfo: " + JSON.stringify(streamInfo));

    const userData = {
      iceServers: [
        { urls: ['stun:stun1.l.google.com:19302', 'stun:stun2.l.google.com:19302'] }
      ],
      sdpSemantics: 'plan-b',
    };

    this.peerConnection = new RTCPeerConnection(userData);

    try {
      this.wsConnection = new WebSocket(this.wssUrl);
    } catch (e) {
      console.log(e);
    }

    if (this.wsConnection) {
      this.wsConnection.binaryType = 'arraybuffer';

      this.wsConnection.onopen = () => {
        console.log("onopen");

        this.peerConnection!.onicecandidate = this.gotIceCandidate;

        this.peerConnection!.ontrack = (event) => {
          console.log('gotRemoteTrack: kind:' + event.track.kind + ' stream:' + event.streams[0]);
          try {
            this.videoElement!.srcObject = event.streams[0];
            console.log("event.streams[0]" , event.streams[0])
          } catch (error) {
            console.error("Error assigning stream to video element", error);
          }
        }
        this.sendPlayGetOffer(streamInfo, userData);
      }

      this.wsConnection.onmessage = (evt) => {
        console.log("wsConnection.onmessage: " + evt.data);
        this.handleWsMessage(evt, streamInfo, userData);
      }

      this.wsConnection.onclose = () => {
        console.log("wsConnection.onclose");
      }

      this.wsConnection.onerror = (evt) => {
        console.log(evt);
      }
    }
  }

  parseStreamNameAndToken = async (streamNameWithToken, secureData) => {
    const baseStreamName = streamNameWithToken.split('?')[0];
    console.log('secureData: ' + JSON.stringify(secureData));
    
    if (secureData) {

      const token = await this.getSecureToken(secureData);
      secureData.hash = token.hash;
      console.log('token: ' + JSON.stringify(token) );
      console.log('secureData: ' + JSON.stringify(secureData));

      if (token) {
        const prefix = secureData.prefix || 'wowzatoken';
        let tokenQuery = `${prefix}hash=${token.hash}`;
        if (token.starttime) {
          tokenQuery += `&${prefix}starttime=${token.starttime}`;
        }
        if (token.endtime) {
          tokenQuery += `&${prefix}endtime=${token.endtime}`;
        }
        if (secureData.isIp && secureData.ip) {
          tokenQuery += `&${prefix}ip=${secureData.ip}`;
        }
        return `${baseStreamName}?${tokenQuery}`;
      }
    }
    
    return baseStreamName;
  };

  
  getSecureToken = async (secureData) => { 

    if (secureData?.SharedKey) {
      let prefix = secureData.prefix;
      if(prefix === undefined || prefix === "") {
        prefix = 'wowzatoken'; // WSE default
      }    

      let url = secureData.applicationName + '/' + secureData.streamName + "?";
      let queryParams = [];
      queryParams.push(secureData.SharedKey);
      if (secureData.isIp) {
        queryParams.push(secureData.ip);
      }
    
      if (secureData.wowzatimeout > 0) {
        let currTime = Math.trunc(new Date().getTime() / 1000);
        secureData.startTime = (currTime - 5).toString();
        secureData.endTime = (currTime + Math.trunc(secureData.wowzatimeout)).toString();
        queryParams.push(prefix + "endtime=" + secureData.endTime);
        queryParams.push(prefix + "starttime=" + secureData.startTime);
      }
    
      queryParams.sort();
      url = url + queryParams.join("&");
      let vDigest = await this.digestMessage(url);

      return { 
        hash: vDigest, 
        starttime: secureData.startTime, 
        endtime: secureData.endTime 
      };
    }
    return null;
  };
  
  async digestMessage(message) {
    console.log('message: ' + message);
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    const hash = await crypto.subtle.digest('SHA-256', data);
    let hashb64 = btoa(new Uint8Array(hash).reduce((data, byte) => data + String.fromCharCode(byte), ''));
    hashb64 = hashb64.replaceAll('/', '_');
    hashb64 = hashb64.replaceAll('+', '-');
    return hashb64;
  }

  sendPlayGetOffer(streamInfo: any, userData: any) {
    console.log("sendPlayGetOffer: " + JSON.stringify(streamInfo));
    this.wsConnection!.send(JSON.stringify({
      direction: "play",
      command: "getOffer",
      streamInfo: streamInfo,
      userData: userData
    }));
  }

  stop() {
    if (this.peerConnection) {
      this.peerConnection.close();
    }
    if (this.wsConnection) {
      this.wsConnection.close();
    }
    this.peerConnection = null;
    this.wsConnection = null;
    if (this.videoElement) {
      this.videoElement.srcObject = null;
    }
  }

  gotIceCandidate = (event: RTCPeerConnectionIceEvent) => {
    if (event.candidate) {
      this.wsConnection!.send(JSON.stringify({ ice: event.candidate }));
    }
  }

  handleWsMessage(evt: MessageEvent, streamInfo: any, userData: any) {
    console.log("handleWsMessage: " + JSON.stringify(streamInfo));
    const msgJSON = JSON.parse(evt.data);
    const msgStatus = Number(msgJSON.status);
    const msgCommand = msgJSON.command;

    if (msgStatus === 514) { // repeater stream not ready
      this.repeaterRetryCount++;
      if (this.repeaterRetryCount < 10) {
        setTimeout(() => this.sendPlayGetOffer(streamInfo, userData), 500);
      } else {
        console.log('Live stream repeater timeout: ' + this.streamName);
        this.stop();
      }
    } else if (msgStatus !== 200) {
      console.log("statusDescription: " + msgJSON.statusDescription);
      this.stop();
      this.currentScreen = 'WebrtcfeedsErrorScreen';
    } else {
      this.handleSdpAndIce(msgJSON, streamInfo, userData);
    }

    if (msgCommand === 'sendResponse' && this.wsConnection) {
      this.wsConnection.close();
      this.wsConnection = null;
    }
  }

  handleSdpAndIce(msgJSON: any, streamInfo: any, userData: any) {
    if (msgJSON.streamInfo) {
      streamInfo.sessionId = msgJSON.streamInfo.sessionId;
    }

    const sdpData = msgJSON.sdp;
    if (sdpData) {
      console.log('sdp: ' + JSON.stringify(sdpData));

      if (this.mungeSDP) {
        msgJSON.sdp.sdp = this.mungeSDP(msgJSON.sdp.sdp);
      }

      console.log("SDP Data: " + msgJSON.sdp.sdp);

      this.peerConnection!.setRemoteDescription(new RTCSessionDescription(msgJSON.sdp))
        .then(() => this.peerConnection!.createAnswer()
          .then(description => {
            this.peerConnection!.setLocalDescription(description)
              .then(() => {
                console.log('sendAnswer');
                this.wsConnection!.send(JSON.stringify({
                  direction: "play",
                  command: "sendResponse",
                  streamInfo: streamInfo,
                  sdp: description,
                  userData: userData
                }));
              })
              .catch(err => console.log('set local description error', err));
          })
        ).catch(err => console.log('set remote description error', err));
    }

    const iceCandidates = msgJSON.iceCandidates;
    if (iceCandidates) {
      for (const candidate of iceCandidates) {
        console.log('iceCandidates: ' + JSON.stringify(candidate));
        this.peerConnection!.addIceCandidate(new RTCIceCandidate(candidate));
      }
    }
  }

  mungeSDP(sdpStr: string): string {
    let sdpLines = sdpStr.split(/\r\n/);
    let sdpStrRet = '';

    for (let sdpLine of sdpLines) {
      if (sdpLine.length === 0) continue;

      if (sdpLine.includes("profile-level-id")) {
        let profileLevelIdIndex = sdpLine.indexOf("profile-level-id") + 17;
        let profileLevelId = sdpLine.substring(profileLevelIdIndex, profileLevelIdIndex + 6);
        let profile = parseInt(profileLevelId.substring(0, 2), 16);
        let constraint = parseInt(profileLevelId.substring(2, 4), 16);
        let level = parseInt(profileLevelId.substring(4, 6), 16);

        if (profile > 0x42) {
          profile = 0x42;
          constraint = 0xE0;
          level = 0x1F;
        }

        let newProfileLevelId = 
          ("00" + profile.toString(16)).slice(-2).toLowerCase() +
          ("00" + constraint.toString(16)).slice(-2).toLowerCase() +
          ("00" + level.toString(16)).slice(-2).toLowerCase();

        sdpLine = sdpLine.replace(profileLevelId, newProfileLevelId);
      }

      sdpStrRet += sdpLine + '\r\n';
    }

    return sdpStrRet;
  }
}
